import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import type { StateTree } from '@makemydeal/dr-dash-types';
import { actions } from '@makemydeal/dr-offer-redux';
import type { GenericObject } from '@makemydeal/dr-platform-types';
import type { AnyAction, Dispatch } from 'redux';
import {
    APPLY_LEASE_CONTRACT_FIELDS,
    APPLY_LEASE_CONTRACT_FIELDS_FAILURE,
    APPLY_LEASE_CONTRACT_FIELDS_SUCCESS,
    REQUEST_LEASE_CONTRACT_FIELDS
} from '../actionTypes/leaseContractingFieldsActionTypes';
import * as offerReduxSelectors from '../selectors/offerRedux';

export const applyLeaseContractFields = (action: AnyFSA) => {
    const paymentCall = action.payload?.meta?.paymentCall || false;
    if (!paymentCall) {
        return {
            type: APPLY_LEASE_CONTRACT_FIELDS_SUCCESS,
            payload: action.payload
        };
    } else {
        return {
            type: APPLY_LEASE_CONTRACT_FIELDS,
            meta: {
                middleware: {
                    payment: paymentCall
                },
                changedFields: action.payload.meta.changedFields || []
            }
        };
    }
};

export const requestLeaseContractFields =
    (fields: any) =>
    (dispatch: Dispatch<AnyAction, StateTree>, getState: () => StateTree): void => {
        const state = getState();
        const vehicleDetails = offerReduxSelectors.getVehicleDetails(state);
        const updatedVehicleDetails = { ...vehicleDetails, mileage: fields?.milesAtInception };

        const updatedVehicle = {
            vehicle: updatedVehicleDetails
        };

        dispatch({
            type: actions.UPDATED_VEHICLE_INFO_DETAILS,
            payload: updatedVehicle
        });

        dispatch({
            type: REQUEST_LEASE_CONTRACT_FIELDS,
            payload: fields
        });
    };

export const applyLeaseContractingError =
    (_action: AnyFSA, messages?: GenericObject[]) =>
    async (dispatch: Dispatch<AnyAction, StateTree>, _getState: () => StateTree): Promise<void> => {
        dispatch({
            type: APPLY_LEASE_CONTRACT_FIELDS_FAILURE,
            payload: messages
        });
    };

export const applyLeaseContractingFieldsSuccess =
    (action: AnyFSA) =>
    async (dispatch: Dispatch<AnyAction, StateTree>, getState: () => StateTree): Promise<void> => {
        const state = getState();
        const currentOfferType = offerReduxSelectors.getCurrentOfferType(state);

        const offerTypePayload = action?.payload?.[currentOfferType];
        const payload = {
            retroMiles: offerTypePayload?.retroMiles,
            initialMilesCharged: offerTypePayload?.initialMilesCharged,
            thresholdMiles: offerTypePayload?.thresholdMiles,
            initialMileageCharged: offerTypePayload?.initialMileageCharged,
            totalExcessMilesPurchased: offerTypePayload?.totalExcessMilesPurchased,
            mileagePenaltyRate: offerTypePayload?.mileagePenaltyRate,
            totalMiles: offerTypePayload?.totalMiles,
            excessMileRate: offerTypePayload?.excessMileRate,
            standardAllowedMiles: offerTypePayload?.standardAllowedMiles,
            inceptionRate: offerTypePayload?.inceptionRate,
            milesAtInception: offerTypePayload?.milesAtInception
        };
        dispatch({
            type: APPLY_LEASE_CONTRACT_FIELDS_SUCCESS,
            payload: payload
        });
    };
